<script setup lang="ts">
import { ref } from "vue";
import { useHelper } from "~/composables/helper";

const props = defineProps({
    selectedState: {
        type: String,
        default: "",
    },
});

const selectedFeatures: any = ref(null);
let sfFilters = "filter[featured:is]=true";
if (props.selectedState) {
    sfFilters += `&filter[state:is]=${props.selectedState.toLowerCase()}`;
}
selectedFeatures.value = await useHelper().getCollection("selected_features", sfFilters, 3, 1, "-date");
// If no selected features are found, try to get without user state
if (!selectedFeatures.value || selectedFeatures.value.length <= 0) {
    selectedFeatures.value = await useHelper().getCollection(
        "selected_features",
        "filter[featured:is]=true",
        3,
        1,
        "-date",
    );
}
</script>

<template>
    <div>
        <div
            v-if="selectedFeatures"
            class="mt-14 mb-1 flex justify-center overflow-x-auto pb-4 md:mb-10 md:pb-0"
        >
            <div
                v-for="feature in selectedFeatures"
                :key="feature.id"
                class="mx-6 w-28 flex-1 cursor-pointer text-center md:w-36 md:flex-none lg:w-52"
            >
                <NuxtLink :to="useHelper().selectedFeatureLink(feature)">
                    <div
                        class="mx-auto mb-2 h-16 w-16 overflow-hidden rounded-full bg-cover bg-center bg-no-repeat md:h-28 md:w-28 lg:h-40 lg:w-40"
                        :style="'background-image: url(' + feature.image[0]?.url + ')'"
                    ></div>
                    <div class="leading-4 md:leading-tight">{{ feature.title }}</div>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
